import { render, staticRenderFns } from "./Movements1.vue?vue&type=template&id=44064fa0&scoped=true&"
import script from "./Movements1.vue?vue&type=script&lang=js&"
export * from "./Movements1.vue?vue&type=script&lang=js&"
import style0 from "./Movements1.vue?vue&type=style&index=0&id=44064fa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44064fa0",
  null
  
)

export default component.exports